// extracted by mini-css-extract-plugin
export default {"button":"pKglt43X","buttonLeft":"NF9JT6BL","buttonRight":"y2ycZ0eH","hidden":"J07e3yJ6","icon":"UcuwbrQ3"};